// extracted by mini-css-extract-plugin
export default {"view_only":"ViewOnly_view_only__yWuXB"};